// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_operation_status_enum */
var HarvestOperationStatusEnum;
(function (HarvestOperationStatusEnum) {
    HarvestOperationStatusEnum["EXPECTED"] = "EXPECTED";
    HarvestOperationStatusEnum["SKIPPED"] = "SKIPPED";
})(HarvestOperationStatusEnum || (HarvestOperationStatusEnum = {}));
;
export default HarvestOperationStatusEnum;
/** Zod schema for harvest_operation_status_enum */
export const harvestOperationStatusEnum = z.nativeEnum(HarvestOperationStatusEnum);
//# sourceMappingURL=HarvestOperationStatusEnum.js.map